/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S3_TitleInputs */

const en_guide_json_schema_s3_title = /** @type {(inputs: Guide_Json_Schema_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practical Example: User Registration`)
};

const ko_guide_json_schema_s3_title = /** @type {(inputs: Guide_Json_Schema_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실전 예제: 사용자 등록`)
};

const ja_guide_json_schema_s3_title = /** @type {(inputs: Guide_Json_Schema_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実践的な例：ユーザー登録`)
};

/**
* | output |
* | --- |
* | "Practical Example: User Registration" |
*
* @param {Guide_Json_Schema_S3_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s3_title = /** @type {((inputs?: Guide_Json_Schema_S3_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S3_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s3_title(inputs)
	if (locale === "ko") return ko_guide_json_schema_s3_title(inputs)
	return ja_guide_json_schema_s3_title(inputs)
});